import { ToastButton } from '@ionic/angular';

/**
 * Interface representing the parameters for a toast message.
 */
export interface ToastParams {
  /**
   * The header to display in the toast.
   */
  header?: string;

  /**
   * The message to display in the toast.
   */
  message: string;

  /**
   * The duration in milliseconds to show the toast message.
   */
  duration?: number;

  /**
   * The position of the toast message.
   * Can be 'top', 'bottom', or 'middle'.
   */
  position?: 'top' | 'bottom' | 'middle';

  /**
   * The color of the toast message.
   * Can be one of the following:
   * 'primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'light', 'medium', 'dark'.
   */
  color?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'light'
    | 'medium'
    | 'dark';

  /**
   * An array of buttons to display in the toast message.
   * Each button can be a string or a ToastButton object.
   */
  buttons?: (string | ToastButton)[];
}

/**
 * Default duration for creating new items.
 *
 * @note
 * A new item created toast will display a header and message, so it needs to be shown
 * long enough for the user to read both.
 */
export const CREATE_NEW_DURATION_MS = 6000;

export const CREATE_NEW_TOAST_BUTTONS: (string | ToastButton)[] = [
  {
    icon: 'close',
    role: 'cancel',
    side: 'end',
  },
];
